export const LOADING_STEPS = {
  ANALYZE_MARKET: 1,
  RESEARCH_PRODUCTS: 2,
  CURATE_BESTSELLERS: 3,
  OPTIMIZE_SELECTION: 4,
  FINALIZE_COLLECTION: 5,
} as const;

export const STEP_TRANSLATIONS: Record<number, string> = {
  [LOADING_STEPS.ANALYZE_MARKET]: 'products.loader.step_one',
  [LOADING_STEPS.RESEARCH_PRODUCTS]: 'products.loader.step_two',
  [LOADING_STEPS.CURATE_BESTSELLERS]: 'products.loader.step_three',
  [LOADING_STEPS.OPTIMIZE_SELECTION]: 'products.loader.step_four',
  [LOADING_STEPS.FINALIZE_COLLECTION]: 'products.loader.step_five',
};

export const TOTAL_ANIMATION_TIME = 10000; // 10 seconds total
export const ENABLE_DELAY = 500; // Delay before enabling products
